<div class="background-image shadow">
  <figure *ngIf="stream.background">
    <mb-media class="absolute-centered" [media]="stream.background" [playsInline]="true"></mb-media>
  </figure>
</div>

<div class="stream-card-content">
  <div class="stream-card-hash-wrapper copy-s">{{ stream.titleHash }}</div>
  <div class="stream-card-content-inner">
    <span *ngIf="stream.status === videoStatus.LIVE" class="stream-indicator-text">
      {{ stream.liveStatusIndicatorText }}
      <mb-live-indicator></mb-live-indicator>
    </span>

    <h2 *ngIf="stream.title" class="stream-card-title" [innerHtml]="stream.title"></h2>

    <mb-countdown
      *ngIf="stream.countdownDate && !countdownFinished && !startDateReached"
      [countdownTo]="stream.countdownDate"
      [countdownLabel]="stream.countdownLabel"
      [countdownType]="isMobile ? countdownTypes.FLAT : countdownType"
      (finished)="setCountdownDateReached()"
    ></mb-countdown>

    <div *ngIf="stream.status === videoStatus.STOPPED && stream.showLoadingAnimation" class="buffer-container">
      <mb-buffering class="light"></mb-buffering>
    </div>

    <div
      *ngIf="stream.status === videoStatus.LIVE || stream.status === videoStatus.VOD"
      class="stream-card-btn-wrapper"
    >
      <button class="btn" [routerLink]="[]" [queryParams]="{ video: stream.id }">
        <span class="mb-icon mb-icon-rewatch"></span>
        <span>{{ stream.playButtonText || ('PLAY_NOW' | translate) }}</span>
      </button>
    </div>

    <div *ngIf="stream.subtitle" class="stream-card-subtitle copy-l" [innerHtml]="stream.subtitle"></div>
  </div>
  <div class="fuel-labels-wrapper copy-s">
    <span *ngIf="stream.fuelLabel" class="fuel-label" [innerHTML]="stream.fuelLabel"></span>
  </div>
</div>
